import { render } from "./WorkSpaceOrganizationView.vue?vue&type=template&id=025e4f26"
import script from "./WorkSpaceOrganizationView.vue?vue&type=script&lang=js"
export * from "./WorkSpaceOrganizationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__